import './AppFooter.css';

export const AppFooter = () => {
    return (<div className="AppFooter">
        <div className='TextItems'>
        <div className='Сonfidential'>Политика конфиденциальности</div>
        <div className='Сopyright'>InvestMind©2023</div>
        </div>
    </div>)
}